import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

import {
  IQuestionCommentProps,
  IQuestionThreadProps,
  QuestionV2,
} from '~/lib/discussions/types';
import { useEventDispatch } from '~/lib/events';
import useUser from '~/lib/user';
import QuestionComment from './QuestionComment';
import QuestionCommentInput from './QuestionCommentInput';

function QuestionThread({
  questionId,
  dealId,
  comments = [],
}: Readonly<IQuestionThreadProps>) {
  const [hasReply, setHasReply] = useState(false);
  const { user } = useUser();
  const dispatchEvent = useEventDispatch();

  const onSuccessCallback = (comment: QuestionV2) => {
    setHasReply(true);
    dispatchEvent('comment:mutate', comment);
  };

  return (
    <div
      data-id={questionId}
      data-testid="question-thread"
      className="w-full space-y-4 pt-4"
    >
      {user?.is_authenticated && !hasReply && (
        <QuestionCommentInput
          comment={{ id: questionId }}
          dealId={dealId}
          placeholder="Add a comment..."
          onSuccess={onSuccessCallback}
        />
      )}

      {hasReply && (
        <div
          data-testid="thread-success-message"
          className="flex gap-2 rounded-sm bg-money-moss p-4 px-2 text-sm text-white"
        >
          <FontAwesomeIcon icon={faCheckCircle} className="pt-1 text-lg" />
          <p>
            <b>Thank you for submitting!</b> To keep our community as helpful as
            possible, we moderate all comments and reviews.
          </p>
        </div>
      )}

      {comments?.map((comment: IQuestionCommentProps) => (
        <QuestionComment key={comment.id} {...comment} />
      ))}
    </div>
  );
}

export default QuestionThread;
